import { colors } from '@insurancemenu/imenu-components-lib';
import { createUseStyles } from 'react-jss';

const styles = {
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    border: `1px solid ${colors.neutral[300]}`,
    borderRadius: '6px',
    padding: '4rem',
    marginBottom: '4.2rem',
    width: '100%',
    boxSizing: 'border-box',
  },
  portfolioInput: { width: '100%', marginBottom: '4.5rem' },
  productsWrapper: { marginBottom: '4.2rem', '&:last-of-type': { marginBottom: 0 } },
  productsTitleWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: `1px solid ${colors.neutral[700]}`,
    paddingBottom: '1rem',
    color: colors.neutral[900],
  },
  productsTitle: {
    margin: 0,
    fontSize: '1.8rem',
    lineHeight: '2.4rem',
  },
  productsSubtitle: {
    fontSize: '1.4rem',
    lineHeight: '2.4rem',
  },
  productsList: {
    listStyle: 'none',
    padding: 0,
    margin: 0,
  },
  productRecord: {
    paddingTop: '1rem',
    display: 'flex',
    justifyContent: 'space-between',
    fontSize: '1.4rem',
    lineHeight: '2.4rem',
  },
  actionBtn: { fontWeight: '700' },
  maxProductsReachedMsg: {
    color: colors.neutral[900],
    backgroundColor: colors.neutral[100],
    fontSize: '1.6rem',
    lineHeight: '2.4rem',
    padding: '1rem',
    marginTop: '1rem',
    borderRadius: '0.4rem',
  },
  errorDisclaimer: {
    margin: '1rem 0 0',
    fontSize: '1.4rem',
    color: colors.red[600],
  },
  submitButtonWrapper: { padding: '0rem 2rem' },
};

const createStyles = createUseStyles(styles);

export { createStyles };
